import { render, staticRenderFns } from "./FiltersPreview.vue?vue&type=template&id=5d845acb&lang=pug&"
import script from "./FiltersPreview.vue?vue&type=script&lang=js&"
export * from "./FiltersPreview.vue?vue&type=script&lang=js&"
import style0 from "./FiltersPreview.vue?vue&type=style&index=0&id=5d845acb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports